import React from 'react';

export const withSuspense = (
  WrappedComponent: any,
  FallbackComponent: any = null
) => {
  return class extends React.Component {
    render() {
      if (!FallbackComponent) FallbackComponent = '...loading'; // by default
      return (
        <React.Suspense fallback={FallbackComponent}>
          <WrappedComponent {...this.props} />
        </React.Suspense>
      );
    }
  };
};
